import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { atomIsGroup } from "src/storage";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";
export const useStepper = (currentStep: number) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveBp();

  const [visibleSteps, setVisibleSteps] = useState<string[]>([]);
  const [visualActiveStep, setVisualActiveStep] = useState<number>(0);

  const isGroup = useRecoilValue(atomIsGroup);

  const steps: string[] = [
    t("data_entry.stepper.step_1_title"),
    ...(isGroup ? [t("data_entry.stepper.step_2_groups_title")] : []),
    t("data_entry.stepper.step_2_title"),
    t("data_entry.stepper.step_3_title"),
    t("data_entry.stepper.step_4_title"),
    t("data_entry.stepper.step_5_title"),
  ];

  useEffect(() => {
    if (!isMobile) {
      setVisibleSteps(steps);
      setVisualActiveStep(currentStep);
      return;
    }

    const totSteps = steps.length - 1;
    let start = currentStep - 1;
    let end = currentStep + 1;

    if (currentStep === 0) {
      start = 0;
      end = 2;
    }

    if (currentStep === totSteps) {
      start = totSteps - 2;
      end = totSteps;
    }

    start = Math.max(0, start);
    end = Math.min(totSteps, end);

    const visibleSteps = steps.slice(start, end + 1);
    setVisibleSteps(visibleSteps);

    const visualActiveStep = currentStep - start;
    setVisualActiveStep(visualActiveStep);
  }, [isMobile, currentStep]);

  return {
    visibleSteps,
    visualActiveStep,
  };
};
